import { Global, BaoCao } from '../shared/global';
export const Home = {
    id: '77CCC1E2-FDBC-4644-9C99-3AB9EC1B741E',
    text: 'Quản lý dự án',
    link: '/home',
    icon: 'fas fa-project-diagram'
};


export const NghiepVus_nhaplieumau01 = { id: 'C7CE86D5-2FF0-4BA5-9B93-DAA964D03B6B', text: 'Mẫu 01 - Biểu 01_Đăng ký - Đăng ký điều chỉnh - Hệ thống kho xăng dầu có nguồn gốc hóa thạch / nhiên liệu sinh học của doanh nghiệp', link: '/nghiepvu/bc01', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau0102 = { id: 'A78618AD-EF7F-44E6-A6E2-201AF7B6E2DA', text: 'Mẫu 01 - Biểu 02_Đăng ký - Đăng ký điều chỉnh - Hệ thống phân phối xăng dầu có nguồn gốc hóa thạch / nhiên liệu sinh học của doanh nghiệp', link: '/nghiepvu/bc0102', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau02 = { id: '70CDBFE1-9004-423B-88B0-3A9AD9711A78', text: 'Mẫu 02 - Biểu 01_Báo cáo Nhập - Xuất - Tồn kho xăng dầu', link: '/nghiepvu/bc02', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau022 = { id: '4419D77E-56A2-496D-A211-BDB3CFDFA8DE', text: 'Mẫu 02 - Biểu 02_Báo cáo tồn kho xăng dầu theo ba miền', link: '/nghiepvu/bc022', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau05 = { id: '24BD5439-2CEB-4162-92D4-EBD165323475', text: 'Mẫu 05 - Báo cáo tình hình nhập khẩu - mua từ nguồn sản xuất trong nước - pha chế - xuất khẩu - tạm nhập tái xuất - chuyển khẩu xăng dầu', link: '/nghiepvu/bc05', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau06 = { id: '983431CB-7E25-4494-81A0-DE9CE0082D3D', text: 'Mẫu 06_Đăng ký kế hoạch sản xuất xăng dầu - nhập khẩu nguyên liệu để sản xuất xăng dầu - tiêu thụ sản phẩm xăng dầu', link: '/nghiepvu/bc06', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau07 = { id: '23199FED-325F-48F7-8E7C-3A83E68F3340', text: 'Mẫu 07A_Báo cáo sản lượng xăng dầu xuất bán của nhà máy lọc dầu', link: '/nghiepvu/bc07', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau0703 = { id: 'CE6CEDEC-5F75-409A-8FA5-B5BF923FABFE', text: 'Mẫu 07_Báo cáo thực hiện kế hoạch sản xuất xăng dầu - nhập khẩu nguyên liệu để sản xuất xăng dầu - tiêu thụ sản phẩm xăng dầu-NEW', link: '/nghiepvu/bc0703', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau0702 = { id: '9734BF3A-6E36-4D85-8C49-EEE122CAD547', text: 'Mẫu 07_Báo cáo thực hiện kế hoạch sản xuất xăng dầu - nhập khẩu nguyên liệu để sản xuất xăng dầu - tiêu thụ sản phẩm xăng dầu', link: '/nghiepvu/bc0702', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau08 = { id: '4C60DBAA-C69E-4878-B214-933D653D4F44', text: 'Mẫu 08_Báo cáo về quỹ bình ổn giá xăng dầu', link: '/nghiepvu/bc08', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau0802 = { id: '859F8E53-F49A-4763-9032-7B696751BB01', text: 'Mẫu 08A_Báo cáo về quỹ bình ổn giá xăng dầu tạm ứng từ NSNN(Phụ lục 02 - Thông tư 19/2026/TT-BCT)', link: '/nghiepvu/bc0802', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau0803 = { id: '914B2F9D-42ED-4832-BCAE-D65461C2202C', text: 'Mẫu 08B_Báo cáo nhanh tình hình thực hiện quỹ bình ổn theo kỳ điều hành', link: '/nghiepvu/bc0803', huongdan: Global.App_url, };
export const NghiepVus_chucnang11 = { id: '6EAC2589-462E-4589-9BE0-35E758788A09', text: 'Mẫu 09_Danh mục kho xăng dầu hiện có được tồn tại trong quy hoạch', link: '/nghiepvu/chucnang11/6EAC2589-462E-4589-9BE0-35E758788A09', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau10 = { id: '756C8AD5-A7C8-445F-89C9-AB70EEA86C64', text: 'Mẫu 13 - Bảng kê khai mức giá LPG', link: '/nghiepvu/bc10', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau11 = { id: '6B3AEA43-E079-4D6A-9A27-5251958D547F', text: 'Mẫu 14 - Bảng kê khai mức giá LNG', link: '/nghiepvu/bc11', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau12 = { id: '87FDA494-9C6E-4C11-B88C-66067CC2C0AF', text: 'Mẫu 15 -  Báo cáo tình hình phân phối rượu', link: '/nghiepvu/bc12', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau13 = { id: '2FC41A3D-7318-4FB9-9F5C-DA699CBB7DE6', text: 'Mẫu 17 -  Báo cáo tình hình kinh doanh thuốc lá', link: '/nghiepvu/bc13', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau1202 = { id: '17AF6C6C-4A6D-40B4-BC0E-9654ED07DEFF', text: 'Mẫu 16 -  Báo cáo tình hình sản xuất, tiêu thụ rượu', link: '/nghiepvu/bc1202', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau17 = { id: 'EC60D2A4-3345-490E-96CD-F4954D7DA4C8', text: 'Báo cáo điều chỉnh giá', link: '/nghiepvu/bc17', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau09 = { id: 'F115C290-543A-4E1B-8546-275A2CF8150E', text: 'Mẫu 09 - Bảng kê khai mức giá xăng dầu', link: '/nghiepvu/bc09', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau1101 = { id: '3EE4F1C0-CE2C-4D97-8F28-590D0C1650D8', text: 'Mẫu 11 - Báo cáo tình hình sử dụng và cho thuê kho xăng dầu', link: '/nghiepvu/bc1101', huongdan: Global.App_url, };
export const NghiepVus_nhaplieumau1201 = { id: '022B0C08-42C0-4B20-8C95-66AD3963B303', text: 'Mẫu 12 - Báo cáo tính hình sử dụng kho xăng dầu đi thuê', link: '/nghiepvu/bc1201', huongdan: Global.App_url, };
export const NghiepVus_chucnang21 = { id: 'E3184559-E20B-4B28-8A4C-51E95719A256', text: 'Quản lý khác 10', link: '/nghiepvu/chucnang21/E3184559-E20B-4B28-8A4C-51E95719A256', huongdan: Global.App_url, };
export const NghiepVus_chucnang22 = { id: '98D8A819-3A29-441F-A13D-4C711FCCBE05', text: 'Quản lý khác 11', link: '/nghiepvu/chucnang22/98D8A819-3A29-441F-A13D-4C711FCCBE05', huongdan: Global.App_url, };
export const NghiepVus_chucnang23 = { id: '787F0C4D-4BB5-4F43-A8B1-4CCB322F9CF0', text: 'Quản lý khác 12', link: '/nghiepvu/chucnang23/787F0C4D-4BB5-4F43-A8B1-4CCB322F9CF0', huongdan: Global.App_url, };
export const NghiepVus_chucnang24 = { id: 'B68352A8-D768-40D8-939B-4D7E62C0FF84', text: 'Quản lý khác 13', link: '/nghiepvu/chucnang24/B68352A8-D768-40D8-939B-4D7E62C0FF84', huongdan: Global.App_url, };
export const NghiepVus_chucnang25 = { id: 'B7AC6A99-B999-4E24-A939-25C1ADC88BD3', text: 'Quản lý khác 14', link: '/nghiepvu/chucnang25/B7AC6A99-B999-4E24-A939-25C1ADC88BD3', huongdan: Global.App_url, };
export const NghiepVus_chucnang26 = { id: '3C213AF0-17EC-490D-A27D-229196A43A58', text: 'Quản lý khác 15', link: '/nghiepvu/chucnang26/3C213AF0-17EC-490D-A27D-229196A43A58', huongdan: Global.App_url, };
export const NghiepVus_chucnang27 = { id: 'F8C72794-D59E-4207-8191-981849986B4A', text: 'Quản lý khác 16', link: '/nghiepvu/chucnang27/F8C72794-D59E-4207-8191-981849986B4A', huongdan: Global.App_url, };
export const NghiepVus_chucnang29 = { id: '2F765573-72BF-414A-B53C-D0169C6A0057', text: 'Quản lý khác 18', link: '/nghiepvu/chucnang29/2F765573-72BF-414A-B53C-D0169C6A0057', huongdan: Global.App_url, };
export const NghiepVus_chucnang30 = { id: '81296EC8-CCEF-46E1-9B57-D2DFCBFE8718', text: 'Quản lý khác 19', link: '/nghiepvu/chucnang30/81296EC8-CCEF-46E1-9B57-D2DFCBFE8718', huongdan: Global.App_url, };
export const NghiepVus_khoasolieu = { id: '1B2C983E-49C4-40D0-967A-BDB421BB98EE', text: 'Khóa số liệu', link: '/quantri/khoasolieu', huongdan: Global.App_url, };
export const NghiepVus_giaobaocao = { id: '0B2B127B-534D-4BCB-890A-C4557AA97761', text: 'Giao báo cáo', link: '/baocao/giaobaocao/0B2B127B-534D-4BCB-890A-C4557AA97761', huongdan: Global.App_url, };

export const NghiepVus_danhsachcauhinhgiaobaocao = { id: '0B2B127B-534D-4BCB-890A-C4557AA97761', text: 'Danh sách cấu hình giao báo cáo tự động', link: '/quantri/cauhinhgiaobaocao', huongdan: Global.App_url, }; 

export const NghiepVus_quanlycapgiayphep = { id: '1DC84E76-7C90-4C1A-8023-8DD14C730801', text: 'Quản lý cấp giấy phép', link: '/nghiepvu/giayphep', huongdan: Global.App_url, };
export const NghiepVus_theodoinguonxangdau = { id: '4A6F8B12-C3D4-4E5F-9A01-B2C3D4E5F607', text: 'Theo dõi nguồn xăng dầu', link: '/nghiepvu/nguonxangdau', huongdan: Global.App_url, };
export const NghiepVus_nguonxd_hanmuc = { id: '4A6F8B12-C3D4-4E5F-9A01-B2C3D4E5F611', text: 'Hạn mức phân giao', link: '/nghiepvu/nguonxangdau', huongdan: Global.App_url, };
export const NghiepVus_nguonxd_tondau = { id: '4A6F8B12-C3D4-4E5F-9A01-B2C3D4E5F612', text: 'Tồn đầu kỳ', link: '/nghiepvu/nguonxangdau', huongdan: Global.App_url, };
export const NghiepVus_nguonxd_phieunhap = { id: '4A6F8B12-C3D4-4E5F-9A01-B2C3D4E5F613', text: 'Phiếu nhập', link: '/nghiepvu/nguonxangdau', huongdan: Global.App_url, };
export const NghiepVus_nguonxd_phieuxuat = { id: '4A6F8B12-C3D4-4E5F-9A01-B2C3D4E5F614', text: 'Phiếu xuất', link: '/nghiepvu/nguonxangdau', huongdan: Global.App_url, };
export const NghiepVus_nguonxd_gia = { id: '4A6F8B12-C3D4-4E5F-9A01-B2C3D4E5F615', text: 'Giá xăng dầu hiện tại', link: '/nghiepvu/nguonxangdau', huongdan: Global.App_url, };
export const NghiepVus_phangiaohanmuc = { id: '4A6F8B12-C3D4-4E5F-9A01-B2C3D4E5F616', text: 'Phân giao hạn mức nguồn xăng dầu', link: '/nghiepvu/phangiaohanmuc', huongdan: Global.App_url, };
export const NghiepVus_cauhinhchitieunguonxd = { id: '5B7F9C23-D4E5-4F60-AB12-C3D4E5F60718', text: 'Cấu hình chỉ tiêu xăng dầu đơn vị', link: '/nghiepvu/cauhinhchitieunguonxd', huongdan: Global.App_url, };

//export const TapHuans_hoso = { id: '8801AFE0-0045-4DD6-967F-3DC041B6B20A', text: 'Danh sách cán bộ tập huấn', link: '/hosocongchuc/hoso', huongdan: Global.App_url, };
//export const DauTus_HoSo = { id: '8801AFE0-0045-4DD6-967F-3DC041B6B20A', text: 'Thông tin cán bộ', link: '/hosocongchuc/hoso', huongdan: Global.App_url };

export const NghiepVus = {
  id: '',
  text: 'Nghiệp vụ',
  icon: 'fas fa-certificate',
  submenu: [

    NghiepVus_nhaplieumau01,
    NghiepVus_nhaplieumau0102,
    NghiepVus_nhaplieumau02,
    NghiepVus_nhaplieumau022,
    NghiepVus_nhaplieumau05,
    NghiepVus_nhaplieumau06,
    NghiepVus_nhaplieumau07,
      //NghiepVus_nhaplieumau0702,
    NghiepVus_nhaplieumau0703,
    NghiepVus_nhaplieumau08,
    NghiepVus_nhaplieumau0802,
    NghiepVus_nhaplieumau0803,
    NghiepVus_nhaplieumau09,
    NghiepVus_nhaplieumau1101,
    NghiepVus_nhaplieumau1201,
    NghiepVus_nhaplieumau10,
    NghiepVus_nhaplieumau11,

    // sau tách rượu, thuốc lá
    NghiepVus_nhaplieumau12,
    NghiepVus_nhaplieumau1202,
    NghiepVus_nhaplieumau13,



    NghiepVus_nhaplieumau17,

   
   
    //NghiepVus_chucnang08,
  

   

    //NghiepVus_chucnang11
    NghiepVus_theodoinguonxangdau,
    NghiepVus_phangiaohanmuc,
    NghiepVus_cauhinhchitieunguonxd,
    NghiepVus_giaobaocao,
    NghiepVus_quanlycapgiayphep,
    NghiepVus_khoasolieu
    
  ]
};


//----------------------Bao cao-------------------------------------------------------
// đầu tư
export const Reports_bc01 = { id: 'BC351845-7870-4FDD-B33C-A44846B1B185', text: 'Mẫu 01 - Biểu 01_Đăng ký - Đăng ký điều chỉnh - Hệ thống kho xăng dầu có nguồn gốc hóa thạch / nhiên liệu sinh học của doanh nghiệp', link: '/baocao/bc01/BC351845-7870-4FDD-B33C-A44846B1B185', huongdan: Global.App_url, };
export const Reports_bc0102 = { id: '47C2A1E7-B7BE-4A41-96B0-D3CA5D2F804F', text: 'Mẫu 01 - Biểu 02_Đăng ký - Đăng ký điều chỉnh - Hệ thống phân phối xăng dầu có nguồn gốc hóa thạch / nhiên liệu sinh học của doanh nghiệp', link: '/baocao/bc0102/47C2A1E7-B7BE-4A41-96B0-D3CA5D2F804F', huongdan: Global.App_url, };
export const Reports_bc02_mau01 = { id: '7BF89A25-C000-4E42-BCE4-602E04B63127', text: 'Mẫu 02 - Biểu 01_Báo cáo Nhập - Xuất - Tồn kho xăng dầu', link: '/baocao/bc02_mau01/7BF89A25-C000-4E42-BCE4-602E04B63127', huongdan: Global.App_url, };
export const Reports_bc02_mau02 = { id: '0217EE0A-A910-468D-8915-6BFE3CF28C09', text: 'Mẫu 02 - Biểu 02_Báo cáo tồn kho xăng dầu theo ba miền', link: '/baocao/bc02_mau02/0217EE0A-A910-468D-8915-6BFE3CF28C09', huongdan: Global.App_url, };
export const Reports_bc05 = { id: '4BDC6A56-C92F-4160-8655-A123890218E1', text: 'Mẫu 05 - Báo cáo tình hình nhập khẩu - mua từ nguồn sản xuất trong nước - pha chế - xuất khẩu - tạm nhập tái xuất - chuyển khẩu xăng dầu', link: '/baocao/bc05/4BDC6A56-C92F-4160-8655-A123890218E1', huongdan: Global.App_url, };
export const Reports_bc06 = { id: '99496F5D-873D-4CB3-9387-A348C330FFB0', text: 'Mẫu 06_Đăng ký kế hoạch sản xuất xăng dầu - nhập khẩu nguyên liệu để sản xuất xăng dầu - tiêu thụ sản phẩm xăng dầu', link: '/baocao/bc06/99496F5D-873D-4CB3-9387-A348C330FFB0', huongdan: Global.App_url, };
export const Reports_bc07 = { id: 'B8BD15D9-5805-4AE6-A66B-51AEF4393978', text: 'Mẫu 07A_Báo cáo sản lượng xăng dầu xuất bán của nhà máy lọc dầu', link: '/baocao/bc07/B8BD15D9-5805-4AE6-A66B-51AEF4393978', huongdan: Global.App_url, };
export const Reports_bc0703 = { id: 'ECE8C9E9-E48F-4245-8733-5D5D76F4AB62', text: 'Mẫu 07_Báo cáo thực hiện kế hoạch sản xuất xăng dầu - nhập khẩu nguyên liệu để sản xuất xăng dầu - tiêu thụ sản phẩm xăng dầu-NEW', link: '/baocao/bc0703/ECE8C9E9-E48F-4245-8733-5D5D76F4AB62', huongdan: Global.App_url, };
export const Reports_bc0702 = { id: '951E8C39-0AB0-4F22-914A-0829015DDE34', text: 'Mẫu 07_Báo cáo thực hiện kế hoạch sản xuất xăng dầu - nhập khẩu nguyên liệu để sản xuất xăng dầu - tiêu thụ sản phẩm xăng dầu', link: '/baocao/bc0702/951E8C39-0AB0-4F22-914A-0829015DDE34', huongdan: Global.App_url, };
export const Reports_bc08 = { id: '9F269D4E-8BC4-4E8C-8925-32597EBED9D1', text: 'Mẫu 08_Báo cáo về quỹ bình ổn giá xăng dầu', link: '/baocao/bc08/9F269D4E-8BC4-4E8C-8925-32597EBED9D1', huongdan: Global.App_url, };
export const Reports_bc0802 = { id: '74D46E65-25C8-449E-ACD9-45B879F750C8', text: 'Mẫu 08A_Báo cáo về quỹ bình ổn giá xăng dầu tạm ứng từ NSNN(Phụ lục 02 - Thông tư 19/2026/TT-BCT)', link: '/baocao/bc0802/74D46E65-25C8-449E-ACD9-45B879F750C8', huongdan: Global.App_url, };
export const Reports_bc0803 = { id: '65B37CFE-75A4-4BC2-9E04-3183B1CE1AA8', text: 'Mẫu 08B_Báo cáo nhanh tình hình thực hiện quỹ bình ổn theo kỳ điều hành', link: '/baocao/bc0803/65B37CFE-75A4-4BC2-9E04-3183B1CE1AA8', huongdan: Global.App_url, };
export const Reports_bc0011 = { id: '3C23B951-1F36-4EC4-9029-2C11279E823E', text: 'Mẫu 09_Danh mục kho xăng dầu hiện có được tồn tại trong quy hoạch', link: '/baocao/bc0011/3C23B951-1F36-4EC4-9029-2C11279E823E', huongdan: Global.App_url, };
export const Reports_bc0012 = { id: 'D4B584C6-A3E5-4441-B07F-8807B017630A', text: 'Báo cáo điều chỉnh giá', link: '/baocao/bc0012/D4B584C6-A3E5-4441-B07F-8807B017630A', huongdan: Global.App_url, };
export const Reports_bc10 = { id: '3CD8C834-20DA-4123-881E-E5A7B77A1A30', text: 'Mẫu 13 - Bảng kê khai mức giá LPG', link: '/baocao/bc10/3CD8C834-20DA-4123-881E-E5A7B77A1A30', huongdan: Global.App_url, };
export const Reports_bc11 = { id: '850DB0F0-FB95-4210-B646-9D36B69E802E', text: 'Mẫu 14 - Bảng kê khai mức giá LNG', link: '/baocao/bc11/850DB0F0-FB95-4210-B646-9D36B69E802E', huongdan: Global.App_url, };
export const Reports_bc12 = { id: '7AE62001-9E86-4C83-AA53-28F5545B995D', text: 'Mẫu 15 -  Báo cáo tình hình phân phối rượu', link: '/baocao/bc12/7AE62001-9E86-4C83-AA53-28F5545B995D', huongdan: Global.App_url, };
export const Reports_bc13 = { id: '7EB0267F-59B9-4440-8ADE-24A54B3DEB97', text: 'Mẫu 17 -  Báo cáo tình hình kinh doanh thuốc lá', link: '/baocao/bc13/7EB0267F-59B9-4440-8ADE-24A54B3DEB97', huongdan: Global.App_url, };
export const Reports_bc12_02 = { id: '0078B7D7-3A15-4B65-99EE-EA912E157247', text: 'Mẫu 16 -  Báo cáo tình hình sản xuất, tiêu thụ rượu', link: '/baocao/bc1202/0078B7D7-3A15-4B65-99EE-EA912E157247', huongdan: Global.App_url, };
export const Reports_bc09 = { id: '65C9FEF8-1411-4F60-BB9C-244311336858', text: 'Mẫu 09 - Bảng kê khai mức giá xăng dầu', link: '/baocao/bc09/65C9FEF8-1411-4F60-BB9C-244311336858', huongdan: Global.App_url, };
export const Reports_bc1101 = { id: '78BCE38E-45BA-4F0A-9035-8FAB79CC12FA', text: 'Mẫu 11 - Báo cáo tình hình sử dụng và cho thuê kho xăng dầu', link: '/baocao/bc1101/78BCE38E-45BA-4F0A-9035-8FAB79CC12FA', huongdan: Global.App_url, };
export const Reports_bc1201 = { id: '14121372-DC98-4B64-A4E9-B6339B3CCBCC', text: 'Mẫu 12 - Báo cáo tính hình sử dụng kho xăng dầu đi thuê', link: '/baocao/bc1201/14121372-DC98-4B64-A4E9-B6339B3CCBCC', huongdan: Global.App_url, };
export const Reports_bc0021 = { id: '6E5878CC-925D-4697-9B4A-05F90B2AF7CC', text: 'Báo cáo khác 09', link: '/baocao/bc0021/6E5878CC-925D-4697-9B4A-05F90B2AF7CC', huongdan: Global.App_url, };
export const Reports_bc0022 = { id: 'B3490399-3E90-4033-9D0D-74EA86DBCD72', text: 'Báo cáo khác 10', link: '/baocao/bc0022/B3490399-3E90-4033-9D0D-74EA86DBCD72', huongdan: Global.App_url, };
export const Reports_bc0023 = { id: '4386BB57-B602-4B0E-9588-ACD69B0D6755', text: 'Báo cáo khác 11', link: '/baocao/bc0023/4386BB57-B602-4B0E-9588-ACD69B0D6755', huongdan: Global.App_url, };
export const Reports_bc24 = { id: '87AF78B6-4960-4289-94C4-EE6152509D2F', text: 'Danh sách các báo cáo đã nhập theo đơn vị', link: '/baocao/baocaonhap/87AF78B6-4960-4289-94C4-EE6152509D2F', huongdan: Global.App_url, };
export const Reports_bc25 = { id: '4C80CC92-A9E9-4A32-B77C-EF6E47D65701', text: 'Báo cáo kiểm tra dữ liệu', link: '/baocao/kiemtraloi/4C80CC92-A9E9-4A32-B77C-EF6E47D65701', huongdan: Global.App_url, }; 
export const Reports = {
    id:'',
    text: 'Báo cáo',
    link: '/reports',
  icon: 'fa fas fa-chart-area',  
  submenu: [
      // báo cáo đầu tư

    //Reports_bc0001,
    //Reports_bc0002,
    Reports_bc01,
    Reports_bc0102,

    Reports_bc02_mau01,
    Reports_bc02_mau02,
    Reports_bc05,

    Reports_bc06,
    Reports_bc07,
    //Reports_bc0702,
    Reports_bc0703,

    //Reports_bc0006,
    //Reports_bc0007,
    //Reports_bc0008,
    //Reports_bc0009,
    Reports_bc08,
    Reports_bc0802,
    Reports_bc0803,
    Reports_bc09,
    Reports_bc1101,
    Reports_bc1201,
    Reports_bc10,
    Reports_bc11,

    // để sau tách rượu, thuốc lá
    Reports_bc12,
    Reports_bc12_02,
    Reports_bc13,


    Reports_bc24,
    Reports_bc25,

   
   


    //Reports_bc0011,
    //Reports_bc0012

          
    
  ]
};
//--------------------danh mục

// danh mục chung
export const Lists_nguonkinhphi = {
  id: '9840B305-82FD-4EB9-B275-5ED4B58F8282',
  text: 'Độ khẩn',
  link: '/danhmuc/nguonkinhphi',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_chuong = {
  id: '4DEC2574-8660-4055-8B68-7A0E447045D1',
  text: 'Độ mật',
  link: '/danhmuc/chuong',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaikhoan = {
  id: '766BAEB8-09E0-4F13-8E69-24BB5A3AD2F0',
  text: 'Tội danh',
  link: '/danhmuc/loaikhoan',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_tieumuc = {
  id: '',
  text: 'Loại vụ việc',
  link: '/danhmuc/tieumuc',
  visible: true,
  huongdan: Global.App_url
};





export const Lists_loaitaisan = {
  id: '96A4CB47-2CCF-48FF-B49B-EC55DE24AFEF',
  text: 'Loại tài sản',
  link: '/danhmuc/loaitaisan',
  visible: true,
  huongdan: Global.App_url
};



export const Lists_linhvuc = {
  id: '9840B305-82FD-4EB9-B275-5ED4B58F8282',
  text: 'Lĩnh vực',
  link: '/danhmuc/linhvuc',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_loaivuviec = {
  id: '4DEC2574-8660-4055-8B68-7A0E447045D1',
  text: 'Loại vụ việc',
  link: '/danhmuc/loaivuviec',
  visible: true,
  huongdan: Global.App_url
};
export const Lists_loaicongviec = {
  id: '766BAEB8-09E0-4F13-8E69-24BB5A3AD2F0',
  text: 'Loại công việc',
  link: '/danhmuc/loaicongviec',
  visible: true,
  huongdan: Global.App_url
};

export const Lists_bienphapnghiepvu = {
  id: 'D02C046F-FADD-42E4-B0E1-C78663076640',
  text: 'Biện pháp nghiệp vụ',
  link: '/danhmuc/bienphapnghiepvu',
  visible: true,
  huongdan: Global.App_url
};




export const Lists_loaian = {
  id: 'C984553F-B0E6-454D-BE82-5AB776E76763',
  text: 'Loại án',
  link: '/danhmuc/loaian',
  visible: true,
  huongdan: Global.App_url
};


export const Lists_danhmuccapdonvi = { id: '9B6F13B5-88F8-4CF1-90CF-DAE04C849B26', text: 'Danh mục cấp đơn vị', link: '/danhmuc/capdonvi', huongdan: Global.App_url, };
export const Lists_danhmucchucvu = { id: 'E7A41C2B-6D8F-4A19-9B3E-5C0D8F2A1B74', text: 'Danh mục chức vụ', link: '/danhmuc/chucvu', huongdan: Global.App_url, };
export const Lists_danhmucdonvihanhchinh = { id: '7C3E9F1A-4B2D-4E8C-9A5F-6D1E8B2C4A70', text: 'Đơn vị hành chính', link: '/danhmuc/donvihanhchinh', huongdan: Global.App_url, };
export const Lists_danhmucloaihinhdoanhnghiep = { id: 'A8C3E5F1-2B4D-4A6C-9E8F-1D3B5A7C9E01', text: 'Danh mục loại hình doanh nghiệp', link: '/danhmuc/loaihinhdoanhnghiep', huongdan: Global.App_url, };
export const Lists_danhmuckybaocao = { id: '2CEA2A10-9E2A-4EDF-969A-B4DFBE99C48A', text: 'Danh mục kỳ báo cáo', link: '/danhmuc/kybaocao', huongdan: Global.App_url, };
export const Lists_danhmuc003 = { id: 'DE964E8B-BE82-417F-A7DF-2CFB240E8E44', text: 'Danh mục trạng thái báo cáo', link: '/danhmuc/danhmuc003/DE964E8B-BE82-417F-A7DF-2CFB240E8E44', huongdan: Global.App_url, };
export const Lists_danhmucchitieubaocao = { id: '4316191F-5C48-413C-82B3-DFD870C0FAFE', text: 'Danh mục chỉ tiêu báo cáo', link: '/danhmuc/chitieubaocao', huongdan: Global.App_url, };
export const Lists_danhmucthitruong = { id: '532A61EA-D765-844B-8CBF-E610B209E332', text: 'Danh mục thị trường', link: '/danhmuc/thitruong', huongdan: Global.App_url, };
export const Lists_danhmucduan = { id: '7F3A9C21-6B84-4E2D-9F1A-C8D05E47B3A6', text: 'Danh mục dự án', link: '/danhmuc/duan', huongdan: Global.App_url, };
export const Lists_danhmucdonvitinh = { id: '362DA8C9-9F20-4FFC-BE8B-9AF376F2F32E', text: 'Danh mục đơn vị tính', link: '/danhmuc/donvitinh', huongdan: Global.App_url, };
export const Lists_danhmucnhomgiayphep = { id: 'B8A00ED6-8EA0-462B-B1D0-D41466880EFB', text: 'Danh mục nhóm giấy phép', link: '/danhmuc/nhomgiayphep', huongdan: Global.App_url, };
export const Lists_danhmucloaigiayphep = { id: 'C83F032C-8834-44D8-94B5-D9E5A91D9A56', text: 'Danh mục loại giấy phép', link: '/danhmuc/loaigiayphep', huongdan: Global.App_url, };
export const Lists_danhmucxuatxu = { id: '4A625C2C-BBCF-4EE1-84B0-2BDC221201B7', text: 'Danh mục xuất xứ', link: '/danhmuc/xuatxu', huongdan: Global.App_url, };
export const Lists_danhmuchanghoa = { id: 'ABD85401-87F6-4EB8-BD26-2A9713DF53D8', text: 'Danh mục hàng hóa', link: '/danhmuc/hanghoa', huongdan: Global.App_url, };
export const Lists_danhmucnhacungcap = { id: 'A2E1B866-FE5D-4013-B65F-60DFA1A14620', text: 'Danh mục nhà cung cấp', link: '/danhmuc/nhacungcap', huongdan: Global.App_url, };
export const Lists_danhmuc012 = { id: '2F6B699E-3843-43E7-B2D6-ADCB7C790B40', text: 'Danh mục khác 08', link: '/danhmuc/danhmuc012/2F6B699E-3843-43E7-B2D6-ADCB7C790B40', huongdan: Global.App_url, };
export const Lists_danhmuckhachhang = { id: '82A13F03-EC73-4C68-83E0-BABA4C406121', text: 'Danh mục khách hàng', link: '/danhmuc/khachhang', huongdan: Global.App_url, };
export const Lists_danhmucdonvibanle = { id: '47388AF9-A030-4FD9-BE36-0D8486613028', text: 'Danh sách cửa hàng bán lẻ', link: '/quantri/donvibanle', huongdan: Global.App_url, };
export const Lists_danhmuckhoxangdau = { id: 'D85A5EC3-BB49-4270-BDC0-E4D9AF2C2371', text: 'Danh sách kho xăng dầu', link: '/danhmuc/khoxangdau', huongdan: Global.App_url, };
export const Lists_danhmuc016 = { id: '55D96A87-BF6C-478C-ACB1-D15EF48F04F2', text: 'Danh mục khác 12', link: '/danhmuc/danhmuc016/55D96A87-BF6C-478C-ACB1-D15EF48F04F2', huongdan: Global.App_url, };
export const Lists_danhmuc017 = { id: '09F950DC-0F5C-4587-8826-EB70281753C2', text: 'Danh mục khác 13', link: '/danhmuc/danhmuc017/09F950DC-0F5C-4587-8826-EB70281753C2', huongdan: Global.App_url, };
export const Lists_danhmuc018 = { id: '7649BA2A-7109-4C93-98B6-83EDC2162FF6', text: 'Danh mục khác 14', link: '/danhmuc/danhmuc018/7649BA2A-7109-4C93-98B6-83EDC2162FF6', huongdan: Global.App_url, };
export const Lists_danhmuc019 = { id: '8C99F190-D26B-4F02-8895-A255A862EE4A', text: 'Danh mục khác 15', link: '/danhmuc/danhmuc019/8C99F190-D26B-4F02-8895-A255A862EE4A', huongdan: Global.App_url, };
export const Lists_danhmuc020 = { id: '33945FD1-A14F-4E33-8245-833B33145B14', text: 'Danh mục khác 16', link: '/danhmuc/danhmuc020/33945FD1-A14F-4E33-8245-833B33145B14', huongdan: Global.App_url, };
export const Lists_danhmuc021 = { id: 'BEC6103F-B405-43FB-BDDD-5952B920A765', text: 'Danh mục khác 17', link: '/danhmuc/danhmuc021/BEC6103F-B405-43FB-BDDD-5952B920A765', huongdan: Global.App_url, };
export const Lists_danhmuc022 = { id: 'A2BA250E-34D0-49F4-AC02-2F84AA8A3437', text: 'Danh mục khác 18', link: '/danhmuc/danhmuc022/A2BA250E-34D0-49F4-AC02-2F84AA8A3437', huongdan: Global.App_url, };
export const Lists_danhmuc023 = { id: 'A5AB9C8C-C0EA-45A2-889F-F649325C12DC', text: 'Danh mục khác 19', link: '/danhmuc/danhmuc023/A5AB9C8C-C0EA-45A2-889F-F649325C12DC', huongdan: Global.App_url, }; 
 

export const Lists_loaitailieu = {
  id: '0AF84C3A-B45C-4047-94DE-9D1D8D506200',
  text: 'Loại tài liệu',
  link: '/danhmuc/loaitailieu',
  visible: true,
  huongdan: Global.App_url
};


export const DanhMucs = [
  Lists_danhmuccapdonvi,
  Lists_danhmucchucvu,
  Lists_danhmucdonvihanhchinh,
  Lists_danhmucloaihinhdoanhnghiep,
  Lists_danhmuckybaocao,
  Lists_danhmuc003,
  Lists_danhmucchitieubaocao,
  Lists_danhmucduan,
  Lists_danhmucthitruong,
  Lists_danhmucdonvitinh,
  Lists_danhmucnhomgiayphep,
  Lists_danhmucloaigiayphep,
  Lists_danhmucxuatxu,
  Lists_danhmuchanghoa,
  Lists_danhmucnhacungcap,
  Lists_danhmuckhachhang,
  Lists_danhmucdonvibanle,
  Lists_danhmuckhoxangdau
]
export const Lists = {
    id:'',
    text: 'Danh mục',
    link: '/elements',
    icon: 'fa fa-list-ul',
  submenu: [
    // danh mục chung
    Lists_danhmucduan,
    Lists_danhmuccapdonvi,
    Lists_danhmucchucvu,
    Lists_danhmucdonvihanhchinh,
    Lists_danhmucloaihinhdoanhnghiep,
    Lists_danhmuckybaocao,
    //Lists_danhmuc003,
    Lists_danhmucchitieubaocao,
    Lists_danhmucthitruong,
    Lists_danhmucdonvitinh,
    Lists_danhmucnhomgiayphep,
    Lists_danhmucloaigiayphep,
    Lists_danhmucxuatxu,
    Lists_danhmucdonvibanle,
    Lists_danhmuckhoxangdau

    // dùng cho quản lý rượu, thuốc lá
    //Lists_danhmuchanghoa,
    //Lists_danhmucnhacungcap,
    //Lists_danhmuckhachhang
   ]
  
};

 
//-------------------tiện ích
export const Ultil_nguoidung = {
  id: 'CC11D304-2673-40B5-9E2F-295888991A35',
  text: 'Quản lý người dùng',
  link: '/quantri/nguoidung',
  huongdan: Global.App_url
};
export const Ultil_phanquyen = {
  id: '5EB2FFBB-B173-42FE-B155-AB473CE914C1',
  text: 'Quản lý phân quyền',
  link: '/quantri/vaitro',
  huongdan: Global.App_url
};
export const Ultil_doimatkhau = {
  id: 'EB0CE66D-656D-48C9-8BBA-E74309682A18',
  text: 'Đổi mật khẩu',
  link: '/quantri/doimatkhau',
  huongdan: Global.App_url
};
export const Ultil_cauhinhnhapdulieutuexcel = {
  id: '1EC79DE0-51D4-43EF-BF16-5C8E94CB1CD1',
  text: 'Cấu hình nhập dữ liệu từ excel',
  link: '/quantri/maubaocao',
  huongdan: Global.App_url
};

export const Ultil_quanlytin = {
  id: '1EC79DE0-51D4-43EF-BF16-5C8E94CB1CD1',
  text: 'Quản lý tin tức',
  link: '/quantri/quanlytintuc',
  huongdan: Global.App_url
};



export const Ultil_bug = {
  id: '5159E97E-2428-4C72-999D-DE2F444B2D39',
  text: 'Quản lý test',
  link: '/quantri/bug',
  huongdan: Global.App_url
};
export const Ultil_nhatkytruycap = {
  id: '2391F2AB-836E-48E9-B8C0-BE1FC543E387',
  text: 'Nhật ký truy cập',
  link: '/quantri/nhatkytruycap',
  border:'co',
  huongdan: Global.App_url
};



export const Ultil_timdoituong = {
  id: '3E366F69-BDEE-4D73-963A-6DCAA2BC070B',
  text: 'Tìm đối tượng',
  link: '/nhaplieu/timdoituong',
  huongdan: Global.App_url
};
export const Ultil_kiemtraloi = {
  id: 'C641370B-520E-48CF-A95E-D58E82607D42',
  text: 'Kiểm tra lỗi',
  link: '/nhaplieu/kiemtraloi',
  huongdan: Global.App_url
};
export const Ultil_tailieu = {
  id: '4034D0E4-356E-4CEB-9C1A-2DD64882807C',
  text: 'Quản lý tài liệu',
  link: '/quantri/quanlytailieu',
  huongdan: Global.App_url
};


export const Ultil = {
    id:'',
    text: 'Tiện ích',
    link: '/headingComponents',
  icon: 'fa fas fa-th',
  submenu: [
    Ultil_timdoituong,
    Ultil_kiemtraloi,
   // Ultil_danhsochungtu,
   // Ultil_khoaso,
    Ultil_tailieu,
    Ultil_quanlytin,
    //Ultil_nhatkytruycap,
    Ultil_cauhinhnhapdulieutuexcel,
    //Ultil_cauhinhdongthoi,
    //Ultil_hachtoanquy,
    //Ultil_hachtoankhobac,
    //Ultil_hachtoantaisan,
    //Ultil_hachtoanmuahang,
    //Ultil_hachtoanluong,

    
    ]
};


//----------------------quản trị
export const System_vaitro = {
  id: '5EB2FFBB-B173-42FE-B155-AB473CE914C1',
  text: 'Vai trò',
  link: '/quantri/vaitro',
  border:'co',
  huongdan: Global.App_url
};
export const System_nguoidung = {
  id: 'CC11D304-2673-40B5-9E2F-295888991A35',
  text: 'Người dùng',
  link: '/quantri/nguoidung',
  huongdan: Global.App_url
};
export const System_thamso = {
  id: 'EB0CE66D-656D-48C9-8BBA-E74309682A18',
  text: 'Tham số hệ thống',
  link: '/quantri/thamso',
  huongdan: Global.App_url
};
export const System_cauhinhzalowebotp = {
  id: '7C8E9F0A-1B2C-4D3E-9F8A-6B5C4D3E2F1A',
  text: 'Cấu hình Zalo Web OTP',
  link: '/quantri/cauhinhzalowebotp',
  huongdan: Global.App_url
};
export const Ultil_donvi = {
  id: '610562E5-AA28-45CB-811B-F349395DA524',
  text: 'Quản lý đơn vị',
  link: '/quantri/donvi',
  huongdan: Global.App_url
};



export const Ultil_phanhe = {
  id: 'E84CDFB9-E9BB-4E79-9CEB-74BF2C175331',
  text: 'Cấu trúc phân hệ',
  link: '/quantri/phanhe',
  border: 'co',
  huongdan: Global.App_url
};

export const System_history = {
  id: '',
  text: 'Bản mới',
  link: '/danhmuc/history',
  icon: 'fa fas fa-history',
  huongdan: Global.App_url
};
export const Ultil_saoluudulieu = {
  id: 'DC4D283D-4181-4773-BE7E-D576B1430EB8',
  text: 'Sao lưu dữ liệu',
  link: '/quantri/saoluudulieu',
  huongdan: Global.App_url
};
export const Ultil_phuchoidulieu = {
  id: 'A1B2C3D4-E5F6-7890-ABCD-EF1234567890',
  text: 'Phục hồi dữ liệu',
  link: '/quantri/phuchoidulieu',
  huongdan: Global.App_url
};
export const Ultil_nhatkysaoluu = {
  id: '9B779F0A-3D4B-4CDB-87BB-F41529819CC9',
  text: 'Nhật ký sao lưu',
  link: '/quantri/nhatkysaoluu',
  huongdan: Global.App_url
};
export const Ultil_quanlyphien = {
  id: 'C3D4E5F6-A7B8-9012-CDEF-123456789012',
  text: 'Quản lý phiên đăng nhập',
  link: '/quantri/quanlyphien',
  huongdan: Global.App_url
};
export const Ultil_cauhinhlichsu = {
  id: 'D4E5F6A7-B8C9-0123-DEF0-234567890123',
  text: 'Cấu hình lịch sử thay đổi',
  link: '/quantri/cauhinhlichsu',
  huongdan: Global.App_url
};
export const Ultil_lichsuthaydoi = {
  id: 'E5F6A7B8-C9D0-1234-EF01-345678901234',
  text: 'Lịch sử thay đổi',
  link: '/quantri/lichsuthaydoi',
  huongdan: Global.App_url
};
export const Ultil_phanquyenduan = {
  id: 'A7B8C9D0-E1F2-3456-A789-0123456789AB',
  text: 'Phân quyền dự án',
  link: '/quantri/phanquyenduan',
  huongdan: Global.App_url
};
export const Ultil_quanlychinhsuamaubaocao = {
  id: 'F6A7B8C9-D0E1-2345-F012-45678901ABCD',
  text: 'Quản lý chỉnh sửa mẫu báo cáo',
  link: '/quantri/quanlychinhsuamaubaocao',
  huongdan: Global.App_url
};
export const System = {
  id: '',
  text: 'Hệ thống',
  link: '',
  icon: 'fa fa-cog',
  submenu: [
    Lists_danhmucduan,
    System_thamso,
    Ultil_nhatkytruycap,
    Ultil_cauhinhlichsu,
    Ultil_lichsuthaydoi,
    Ultil_phanquyenduan,
    System_nguoidung,
    System_vaitro,
    Ultil_donvi,
    Ultil_phanhe
  ],
  huongdan: Global.App_url
};

//-----------------------------------------

 


export const menu = [
  Home,
 // DieuHanhChungs,
  // NghiepVus,
  // Reports,
  //Ultil,
  // Lists,
  System
];
